var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-1500 3000 30000 22000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "crossPath",
    fill: "none",
    strokeWidth: 2117,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    d: "M 2100,22700 L 18800,6000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "crossPath",
    fill: "none",
    strokeWidth: 2117,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    d: "M 18800,22700 L 2100,6000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.2ead9053257b3bfe4e4c44d4aa8a50e8.svg";
export { ForwardRef as ReactComponent };